// Account Statements Payable Getters

export const getStatementList = state => {
  return state.statementList
}

export const getStatementInfo = state => {
  return state.statementInfo
}

export const getCashOrOpenList = state => {
  return state.cashOrOpen
}
